import React from 'react';
import Hero from './MainPanner/Hero';
import WhyChooseDoroos from './MainPanner/WhyChooseDoroos';
import Testimonials from './MainPanner/Testimonials';
import FeaturedCourses from './MainPanner/FeaturedCourses';

const HomePage = () => (
  <main>
    <Hero />
    <WhyChooseDoroos/>
    <FeaturedCourses/>
    <Testimonials/>
  </main>
);

export default HomePage;